import { useState } from 'react';
import { AlertOctagon, Bot, Lock } from 'lucide-react';
import { Button, Dialog, DialogContent } from '@/components/ui';
import { readStorage, writeStorage } from '@/lib/storage';

const KEY = 'medicail.consent.v1';

export function ConsentDialog() {
  const [open, setOpen] = useState(() => readStorage(KEY) !== 'accepted');
  const accept = () => {
    writeStorage(KEY, 'accepted');
    setOpen(false);
  };
  const items = [
    { icon: Lock, title: 'Your privacy', body: 'Do not share details you are not comfortable with. Avoid sharing identifiers such as national ID numbers or full addresses.' },
    { icon: Bot, title: 'AI has limits', body: 'MedicAiL can be wrong or out of date. It offers general information and guideline pointers, not a diagnosis or treatment plan. It is not a substitute for a doctor.' },
    { icon: AlertOctagon, title: 'In an emergency', body: 'If you think you or someone else is in danger, or you have chest pain, trouble breathing, stroke symptoms or severe bleeding, call your local emergency number now.' },
  ];
  return (
    <Dialog open={open} onOpenChange={(o) => (o ? setOpen(true) : accept())}>
      <DialogContent title="Before you start" description="A few things worth knowing about MedicAiL.">
        <ul className="mt-5 space-y-4">
          {items.map(({ icon: Icon, title, body }) => (
            <li key={title} className="flex gap-3">
              <span className="grid size-9 shrink-0 place-items-center rounded-xl bg-royal-50 text-royal-600 dark:bg-royal-500/15 dark:text-royal-200">
                <Icon className="size-[18px]" aria-hidden="true" />
              </span>
              <div>
                <h3 className="text-sm font-semibold text-ink">{title}</h3>
                <p className="mt-0.5 text-sm leading-relaxed text-ink-muted">{body}</p>
              </div>
            </li>
          ))}
        </ul>
        <Button size="lg" className="mt-6 w-full" onClick={accept}>
          I understand
        </Button>
      </DialogContent>
    </Dialog>
  );
}
